<template>
  <div class="outer-container" v-if="info.paragraph">
    <div class="container">
      <h2 class="header-font text-center">Position Summary</h2>
      <div class="grid" :style="{ backgroundColor: info.bgColor }">
        <div class="text text-center">
          <h4 class="manrope ">
            {{ info.paragraph }}
          </h4>
          <br />
          <br />
          <h3 class="manrope bold" :style="{ color: info.txtColor }">
            {{ info.remote }}
          </h3>
          <h3 class="manrope bold" :style="{ color: info.txtColor }">
            {{ info.jobType }}
          </h3>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    info: {
      type: Object,
      required: true,
    },
  },
}
</script>

<style scoped>
.outer-container {
  padding-bottom: 50px;
}
.header-font {
  padding-top: 70px;
  font: 800 2.25rem/2.75rem 'Manrope';
  color: #29292b;
  padding-bottom: 50px;
}
.grid {
  max-width: 850px;
  margin: 0 auto;

  display: grid;
  grid-template-columns: 1fr;
}
</style>
